import { ISidebarItem } from './types'
import { SUB_SIDEBAR_KEYS } from 'consts/sidebar'
import { T } from 'consts/translationKeys'
import { dispatch } from 'store'
import { translate } from 'utils/translations'
import MediaIcon from 'assets/svgr-icons/Media.svg'
import AiLib from 'assets/svgr-icons/AI_LIB.svg'
import AIVideoIcon from 'assets/svgr-icons/AI_Video.svg'
import AIimageIcon from 'assets/svgr-icons/AIimage.svg'
import AudioIcon from 'assets/svgr-icons/Audio.svg'
import TTSIcon from 'assets/svgr-icons/TTS.svg'
import Text_Tab from 'assets/svgr-icons/Text_Tab.svg'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'

export const sidebarItems: ISidebarItem[] = [
  {
    key: SUB_SIDEBAR_KEYS.AI_VIDEO,
    icon: <AIVideoIcon />,
    label: translate(T.AI_VIDEO_LABEL),
    customAction: () => dispatch(aiVideoThunks.clearGenerationParams()),
    tabTestId: 'ai-video-tab'
  },
  {
    key: SUB_SIDEBAR_KEYS.AI_IMAGE,
    icon: <AIimageIcon />,
    label: translate(T.AI_IMAGE_LABEL),
    customAction: () => dispatch(aiImageThunks.setTargetMediaItemId(null)),
    tabTestId: 'ai-image-tab'
  },
  {
    key: SUB_SIDEBAR_KEYS.AUDIO,
    icon: <AudioIcon />,
    label: translate(T.AUDIO_LABEL),
    tabTestId: 'audio-tab'
  },
  {
    key: SUB_SIDEBAR_KEYS.TTS,
    icon: <TTSIcon />,
    label: translate(T.TEXT_TO_SPEECH_LABEL),
    tabTestId: 'tts-tab'
  },
  {
    key: SUB_SIDEBAR_KEYS.TEXT,
    icon: <Text_Tab />,
    label: translate(T.TEXT_LABEL),
    tabTestId: 'text-tab',
    isNewLabel: true
  },
  {
    key: SUB_SIDEBAR_KEYS.UPLOAD,
    icon: <MediaIcon />,
    label: translate(T.UPLOAD_LABEL),
    tabTestId: 'upload-tab'
  },
  {
    key: SUB_SIDEBAR_KEYS.AI_LIB,
    icon: <AiLib />,
    label: translate(T.AI_HISTORY),
    tabTestId: 'ai-lib-tab'
  }
]
